import { getUniquePageProducts } from '@app/logic/pages';
import { fetchLookbookProducts } from '@app/services/lookbookRepository';
import { isEmpty } from '@app/utils/isEmpty';
import { useQuery } from '@tanstack/react-query';
import { Cms, Product, ShowroomApiResponse } from '@typings';
import { AxiosError } from 'axios';

export const LOOKBOOK_PAGE_PRODUCTS_QUERY_KEY = 'lookbookPageProducts';

interface Props {
  lookbookId: string;
  blocks: Cms.AnyBlock[];
}

export const useLookbookPageProducts = ({ lookbookId, blocks }: Props) => {
  const uniqueProducts = getUniquePageProducts(blocks);

  return useQuery<ShowroomApiResponse & Product.ProductsResultDTO, AxiosError, Record<Product.Id, Product.Full>>({
    enabled: !isEmpty(uniqueProducts),
    queryFn: async () => fetchLookbookProducts(lookbookId, { products: uniqueProducts }, { limit: uniqueProducts.length, offset: 0 }),
    queryKey: [LOOKBOOK_PAGE_PRODUCTS_QUERY_KEY, lookbookId, uniqueProducts],
    refetchOnMount: false,
    select: data => {
      return data.products;
    },
  });
};
